import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {map, Observable} from 'rxjs';
import {AppConfigService} from '../common/service/app-config.service';
import {PlanModelService} from '../common/service/plan-model.service';
import {AdditionalsViewModel} from '../common/models/additionals-view.model';

@Injectable({
    providedIn: 'root'
})
export class AdditionalsService {
    constructor(
        private http: HttpClient,
        private appConfigService: AppConfigService,
        private planModelService: PlanModelService
    ) {}

    getAdditionals(): Observable<any> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/additionals/getAdditionals/' + this.planModelService.getModel().id;
        return this.http.get<any>(url);
    }

    getAttachmentTypes(): Observable<any> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/attachment/attachments';
        return this.http.post<any>(url, this.planModelService.getModelForSerialisation());
    }

    getSignedUrlForRetrieval(uidWithPrefix: string): Observable<string> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/attachment/signedUrlForRetrieval' + uidWithPrefix;
        return this.http.get<{url: string}>(url).pipe(
            map((data: {url: string}) => {
                return data.url;
            })
        );
    }

    getAdditionalAttachment(signedURL: string): Observable<ArrayBuffer> {
        return this.http.get(signedURL, {responseType: 'arraybuffer'});
    }

    lodgeAdditionals(additionalsViewModel: AdditionalsViewModel): Observable<any> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/additionals/lodge';
        return this.http.post(url, additionalsViewModel);
    }

    getAdditionalImage(request: any): Observable<any> {
        const url = this.appConfigService.settings.apiGatewayUrl + '/additionals/preview';
        return this.http.post(url, request, {responseType: 'arraybuffer'});
    }
}
